import Vue from 'vue'
import storage from '@/services/storage'

const setSlides = (state, payload) => {
  state.slides = payload
}

const setSlidesList = (state, payload) => {
  Vue.set(state, 'slidesList', payload)
  state.slidesList = payload
}

const setSlideIndex = (state, payload) => {
  if (!state.presentation || !state.presentation.id || payload == -1) return
  state.slideIndex = payload
}

const setMaxLookbackSlideIndex = (state, payload) => {
  if (payload > state.maxLookbackSlideIndex) {
    state.maxLookbackSlideIndex = payload
    storage.setValueByPresentation(state.presentation.id, 'maxLookbackSlideIndex', payload)
  }
}

const setSlideV2 = (state, payload) => {
  if (payload && state.slideV2.id != payload.id) {
    state.slideV2 = payload
  }
}

const updateSlideV2 = (state, payload) => {
  state.slideV2 = { ...state.slideV2, ...payload }
}

const updateSlideV2Timestamp = (state, payload) => {
  // Save the timestamp of slideV2 that being set from EMQX message, to be compared with the socket.io message timestamp later on
  state.slideV2Timestamp = {
    [payload.id]: payload.timestamp,
  }
}

export default {
  setSlides,
  setSlidesList,
  setSlideIndex,
  setMaxLookbackSlideIndex,
  setSlideV2,
  updateSlideV2,
  updateSlideV2Timestamp,
}
